import React from "react";
import PropTypes from "prop-types";
import CardAuthor from "../CardAuthor";
import ButtonGridLayout from "../ButtonGridLayout";
import SectionTitle from "../SectionTitle";
import Colors from "../../global/color";
import {
  StyledGridLayout,
  StyledGridLayoutMobile,
  StyledGridColumn,
  StyledGridRow,
} from "./styles";

export const GridLayout = ({
  key = "grid-card",
  id = "grid-card",
  context = null,
  clientContext = null,
  data = null,
  schema = null,
  sectionLabel = null,
  gridTitle = null,
  gridDescription = null,
  showButton = false,
  buttonPath = null,
  buttonLabel = null,
  currentCategorySettings = null,
  dataPath = null,
  section = null,
  imageLoading = null,
}) => {
  let { isMobile, isTablet } = clientContext;

  if (data && data.length > 0) {
    // If is a queue content type, use the data entries instead of the contentful items.
    let contentType = data[0].sys.contentType.sys.id;
    let contentItems = data;
    if (contentType === "queue") {
      contentItems = data[0].fields.entries;
      // console.log("contentItems", contentItems);
    }
    let getImageDimensions = ({ clientContext }) => {
      let { isMobile, isTablet } = clientContext;

      if (isMobile && !isTablet) {
        return {
          large: {
            width: 74,
            height: 74,
          },
        };
      } else if (!isMobile && isTablet) {
        return {
          large: {
            width: 92,
            height: 92,
          },
        };
      } else {
        return {
          large: {
            width: 78,
            height: 78,
          },
        };
      }
    };

    let imageDimensions = getImageDimensions({ clientContext });
    if (isMobile && !isTablet) {
      return (
        <>
          <StyledGridLayoutMobile>
            <StyledGridColumn>
              {sectionLabel && (
                <SectionTitle
                  context={context}
                  clientContext={clientContext}
                  fullWidth={true}
                >
                  {sectionLabel}
                </SectionTitle>
              )}
              <StyledGridRow>
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-0"}
                  data={{ ...contentItems[0] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={0}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-1"}
                  data={{ ...contentItems[1] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={1}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-2"}
                  data={{ ...contentItems[2] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={2}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                  borderBottom: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-3"}
                  data={{ ...contentItems[3] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={3}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                  borderBottom: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-3"}
                  data={{ ...contentItems[4] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={3}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
            </StyledGridColumn>
          </StyledGridLayoutMobile>
          {showButton && (
            <ButtonGridLayout path={buttonPath} label={buttonLabel} />
          )}
        </>
      );
    } else if (isTablet && !isMobile) {
      return (
        <>
          <StyledGridLayoutMobile>
            {sectionLabel && (
              <SectionTitle
                context={context}
                clientContext={clientContext}
                fullWidth={true}
              >
                {sectionLabel}
              </SectionTitle>
            )}
            <StyledGridRow>
              <CardAuthor
                key={"GridLayout_285_1x5_Author-card-0"}
                data={{ ...contentItems[0] }}
                context={context}
                clientContext={clientContext}
                component="GridLayout_285_1x5_Author" // Name, for reference
                index={0}
                padding={null}
                width={imageDimensions.large.width}
                height={imageDimensions.large.height}
                imageLocation="left"
                textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                currentCategorySettings={currentCategorySettings}
                dataPath={dataPath}
                section={section}
                imageLoading={imageLoading}
              />
            </StyledGridRow>
            <StyledGridRow
              style={{
                borderTop: `1px solid ${Colors.lightGrey}`,
              }}
            >
              <CardAuthor
                key={"GridLayout_285_1x5_Author-card-1"}
                data={{ ...contentItems[1] }}
                context={context}
                clientContext={clientContext}
                component="GridLayout_285_1x5_Author" // Name, for reference
                index={1}
                padding={null}
                width={imageDimensions.large.width}
                height={imageDimensions.large.height}
                imageLocation="left"
                textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                currentCategorySettings={currentCategorySettings}
                dataPath={dataPath}
                section={section}
                imageLoading={imageLoading}
              />
            </StyledGridRow>
            <StyledGridRow
              style={{
                borderTop: `1px solid ${Colors.lightGrey}`,
              }}
            >
              <CardAuthor
                key={"GridLayout_285_1x5_Author-card-2"}
                data={{ ...contentItems[2] }}
                context={context}
                clientContext={clientContext}
                component="GridLayout_285_1x5_Author" // Name, for reference
                index={2}
                padding={null}
                width={imageDimensions.large.width}
                height={imageDimensions.large.height}
                imageLocation="left"
                textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                currentCategorySettings={currentCategorySettings}
                dataPath={dataPath}
                section={section}
                imageLoading={imageLoading}
              />
            </StyledGridRow>
            <StyledGridRow
              style={{
                borderTop: `1px solid ${Colors.lightGrey}`,
              }}
            >
              <CardAuthor
                key={"GridLayout_285_1x5_Author-card-3"}
                data={{ ...contentItems[3] }}
                context={context}
                clientContext={clientContext}
                component="GridLayout_285_1x5_Author" // Name, for reference
                index={3}
                padding={null}
                width={imageDimensions.large.width}
                height={imageDimensions.large.height}
                imageLocation="left"
                textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                currentCategorySettings={currentCategorySettings}
                dataPath={dataPath}
                section={section}
                imageLoading={imageLoading}
              />
            </StyledGridRow>
            <StyledGridRow
              style={{
                borderTop: `1px solid ${Colors.lightGrey}`,
                borderBottom: `1px solid ${Colors.gold}`,
                paddingBottom: "20px",
              }}
            >
              <CardAuthor
                key={"GridLayout_285_1x5_Author-card-3"}
                data={{ ...contentItems[4] }}
                context={context}
                clientContext={clientContext}
                component="GridLayout_285_1x5_Author" // Name, for reference
                index={3}
                padding={null}
                width={imageDimensions.large.width}
                height={imageDimensions.large.height}
                imageLocation="left"
                textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                currentCategorySettings={currentCategorySettings}
                dataPath={dataPath}
                section={section}
                imageLoading={imageLoading}
              />
            </StyledGridRow>
          </StyledGridLayoutMobile>
          {showButton && (
            <ButtonGridLayout path={buttonPath} label={buttonLabel} />
          )}
        </>
      );
    } else {
      return (
        <>
          <StyledGridLayout>
            <StyledGridColumn>
              {sectionLabel && (
                <SectionTitle context={context} clientContext={clientContext}>
                  {sectionLabel}
                </SectionTitle>
              )}
              <StyledGridRow>
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-0"}
                  data={{ ...contentItems[0] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={0}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-1"}
                  data={{ ...contentItems[1] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={1}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-2"}
                  data={{ ...contentItems[2] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={2}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-3"}
                  data={{ ...contentItems[3] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={3}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
              <StyledGridRow
                style={{
                  borderTop: `1px solid ${Colors.lightGrey}`,
                }}
              >
                <CardAuthor
                  key={"GridLayout_285_1x5_Author-card-3"}
                  data={{ ...contentItems[4] }}
                  context={context}
                  clientContext={clientContext}
                  component="GridLayout_285_1x5_Author" // Name, for reference
                  index={3}
                  padding={null}
                  width={imageDimensions.large.width}
                  height={imageDimensions.large.height}
                  imageLocation="left"
                  textLayout="TextLayoutList168Row" // @TODO Create new component with author role
                  currentCategorySettings={currentCategorySettings}
                  dataPath={dataPath}
                  section={section}
                  imageLoading={imageLoading}
                ></CardAuthor>
              </StyledGridRow>
            </StyledGridColumn>
          </StyledGridLayout>
          {showButton && (
            <ButtonGridLayout path={buttonPath} label={buttonLabel} />
          )}
        </>
      );
    }
  }
  return null;
};

export default GridLayout;

GridLayout.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
  /**
    Key name for component instance
  */
  key: PropTypes.string,
  /**
    Unique id for this section. Must be alphanumeric with no spaces.
  */
  id: PropTypes.string,
  /**
    Data object. Should be array with items returned from content. If queue, pass it in as an array.
  */
  data: PropTypes.array,
  /**
  Which type of data to display. Options: article, list, queue, or any for mixed results.
  */
  schema: PropTypes.string,
  /**
  Label for the section title (which is a label and section separator.)
  */
  sectionLabel: PropTypes.string,
  /**
  Text of grid component's display title, if any.
  */
  gridTitle: PropTypes.string,
  /**
  If the Call to action button should show.
  */
  showButton: PropTypes.bool,
  /**
  Button Label for Call to action.
  */
  buttonLabel: PropTypes.string,
  /**
  Path for Call to action button.
  */
  buttonPath: PropTypes.string,
  /**
   Loading property for the image.
   */
  imageLoading: PropTypes.string,
};
